import { Clapperboard, Box, Sparkles, Palette, Brush, Camera, PenTool, Film, Image, Gamepad2, Music, Tv } from 'lucide-react';

export const CHANNEL_ICONS = {
  clapperboard: Clapperboard,
  box: Box,
  sparkles: Sparkles,
  palette: Palette,
  brush: Brush,
  camera: Camera,
  pen: PenTool,
  film: Film,
  image: Image,
  gamepad: Gamepad2,
  music: Music,
  tv: Tv
};

export const iconFor = (name) => CHANNEL_ICONS[name] || Tv;

export const LAYOUTS = [
  { key: 'video', label: 'Videos grid' },
  { key: 'model', label: '3D models' },
  { key: 'mixed', label: 'Stills + motion (with filter)' }
];
